import {Component, Input, OnInit} from '@angular/core';
import {JdDyFormOptionItem} from './dy-form.interface';

@Component({
  selector: 'jd-custom-control',
  template: `
    <ng-content></ng-content>
  `,
  styles: []
})
export class CustomControlComponent implements OnInit {
  @Input() customKey: string;
  config: JdDyFormOptionItem;

  constructor() {
  }

  ngOnInit() {
  }

}
